import { render, staticRenderFns } from "./ControversyDocument.vue?vue&type=template&id=e505de60&scoped=true"
import script from "./ControversyDocument.vue?vue&type=script&lang=js"
export * from "./ControversyDocument.vue?vue&type=script&lang=js"
import style0 from "./ControversyDocument.vue?vue&type=style&index=0&id=e505de60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e505de60",
  null
  
)

export default component.exports